'use strict';

var NewExtractHeaderSubpanelDirective = function NewExtractHeaderSubpanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/new-extract-header-subpanel.html'),
    requires: '^rmDataExtractNewExtract',
    link: function link(scope, element) {
      element.find('.gdpr-popover').popover();
    }
  };
};
NewExtractHeaderSubpanelDirective.$inject = [];
module.exports = NewExtractHeaderSubpanelDirective;